@use '../../list-group/list-group-item/list-group-item-vars';

:host {
  @include list-group-item-vars.wb-list-group-item-vars;

  display: flex;
}

:host(:not(:last-of-type)) {
  border-block-end-style: solid;
  border-block-end-width: var(--list-group-border-weight);
  border-block-end-color: var(--list-group-item-border-color);
}

.wb-list-group-item {
  max-width: 100%;
  overflow: hidden;
}
